import ButtonV2, { getButtonClasses } from "components/elements/buttonV2"
import Image from "components/elements/image"
import React from "react"
import { getOptimizedImage } from "utils/optimizeContentfulImage"

import "./home-hero-v2.scss"
import { HomeHeroV2Props } from "./props"

const HomeHeroV2 = ({
  homeHeroCallsToActions,
  homeHeroCards,
  homeHeroImage,
  homeText,
}) => {
  return (
    <section className="hero-v2">
      <div className="container-v2">
        <div className="hero-v2-content">
          <div className="hero-v2-content--header">
            <div className="hero-v2-content--header-title">
              <h1>
                <span>Together</span> <span>we</span> <span>can</span>{" "}
                <span>unlock</span>{" "}
                <span>
                  <u className="hero-v2-underline">more joy</u>
                </span>
              </h1>
              {homeText && <h2>{homeText}</h2>}
            </div>

            <div className="hero-v2-content--header-image">
              <Image
                alt="Hero Image"
                className="hero-v2-image"
                image={homeHeroImage.fluid}
              />
            </div>
          </div>

          {homeHeroCards && homeHeroCards.length > 0 && (
            <div className="hero-v2-tabs">
              {homeHeroCards.map((card, index) => (
                <div
                  className={`hero-v2-tab hero-v2-tab--${
                    index === 0 ? "first" : index === 1 ? "second" : "third"
                  }`}
                  key={card.id || index}
                >
                  {card.homeHeroCardImage && (
                    <img
                      alt={
                        card.homeHeroCardImage.title || card.homeHeroCardTitle
                      }
                      className="hero-v2-card-icon"
                      src={getOptimizedImage(card.homeHeroCardImage.file.url, 'iconLarge')}
                    />
                  )}
                  <p className="hero-v2-image-text">{card.homeHeroCardTitle}</p>
                </div>
              ))}
            </div>
          )}

          <div className="hero-v2-buttons">
            {homeHeroCallsToActions &&
              homeHeroCallsToActions.length > 0 &&
              homeHeroCallsToActions.map((action, index) => (
                <p key={action.id || index}>
                  {" "}
                  <ButtonV2
                    accessibilityLabel={action.accessibilityLabel}
                    className={getButtonClasses(
                      action.buttonStyle || "primary-green",
                      action.buttonSize || "large"
                    )}
                    href={action.path}
                    key={action.id || index}
                    showArrow={action.showArrow === "Yes" ? true : false}
                    text={action.text}
                  />
                </p>
              ))}
          </div>
        </div>

        <div className="hero-v2-image-desktop">
          {homeHeroCards && homeHeroCards.length > 0 && (
            <>
              {homeHeroCards.map((card, index) => (
                <div
                  className={`hero-v2-tab hero-v2-tab--${
                    index === 0 ? "first" : index === 1 ? "second" : "third"
                  }`}
                  key={`image-${card.id || index}`}
                >
                  {card.homeHeroCardImage && (
                    <img
                      alt={
                        card.homeHeroCardImage.title || card.homeHeroCardTitle
                      }
                      className="hero-v2-card-icon"
                      src={getOptimizedImage(card.homeHeroCardImage.file.url, 'iconLarge')}
                    />
                  )}
                  <p className="hero-v2-image-text">{card.homeHeroCardTitle}</p>
                </div>
              ))}
            </>
          )}

          {homeHeroImage?.fluid && (
            <div className="hero-v2-image-wrapper">
              <Image
                alt="Hero Image"
                className="hero-v2-image"
                image={homeHeroImage.fluid}
              />
            </div>
          )}
        </div>
      </div>
    </section>
  )
}

HomeHeroV2.propTypes = HomeHeroV2Props

export default HomeHeroV2
